function n() {
  if (typeof window > "u") return null;
  const e = window;
  return e.SpeechRecognition ?? e.webkitSpeechRecognition ?? null;
}
export {
  n as getSpeechRecognitionCtor
};
